import fieldDefaultUtils from '../fields/field-default';

import type { ConfigFallbackStrategy } from './types';

export class CurrencyFallback implements ConfigFallbackStrategy {
  private fieldType: string;

  constructor(fieldType: string) {
    this.fieldType = fieldType;
  }

  applyFallback(configObj: { [key: string]: any }): void {
    // Set up fallback currencyCode if it's missing or empty.
    const fieldDefaults = fieldDefaultUtils.getDefaultsforType(this.fieldType);
    configObj.currencyISOCode = configObj.currencyISOCode || fieldDefaults?.currencyISOCode || 'USD';
  }
}
